import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { verifyVendor } from "./api";
import { Box, Typography } from "@mui/material";
import DashboardPage from "./page";

export default function VendorPos() {
  const [data, setData] = useState();
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      await verifyVendor(location.pathname.split("/")[2])
        .then((response) => {
          setData(response);
          console.log("Data---------------", { response });
        })
        .catch((error) => {
          console.log(error);
        });
    };
    verifyToken();
  }, []);

  return <DashboardPage data={data} />;
}
